const dictionary = {}
dictionary.CustomerLevel = [// 客户级别
  {id: 1, name: "未评级"},
  {id: 2, name: "1级"},
  {id: 3, name: "2级"},
  {id: 4, name: "3级"}
]
dictionary.CustomerIndustry = [
  // 客户行业
  // 汽车及其零部件、摩托车及零部件、航空航天、设备工具、国防军工、石油、化工、铁道、船舶、冶金、矿山、能源、电力、水利、工程机械、农业机械、塑料机械、医疗器械、仪器仪表、建筑建材、轻工、纺织、林业、电子、教育、科研、物流、模具、板材加工、电信、其他
  {id: 1, name: "汽车及其零部件"},
  {id: 2, name: "摩托车及零部件"},
  {id: 3, name: "航空航天"},
  {id: 4, name: "设备工具"},
  {id: 5, name: "国防军工"},
  {id: 6, name: "石油"},
  {id: 7, name: "化工"},
  {id: 8, name: "铁道"},
  {id: 9, name: "船舶"},
  {id: 10, name: "冶金"},
  {id: 11, name: "矿山"},
  {id: 12, name: "能源"},
  {id: 13, name: "电力"},
  {id: 14, name: "水利"},
  {id: 15, name: "工程机械"},
  {id: 16, name: "农业机械"},
  {id: 17, name: "塑料机械"},
  {id: 18, name: "医疗器械"},
  {id: 19, name: "仪器仪表"},
  {id: 20, name: "建筑建材"},
  {id: 21, name: "轻工"},
  {id: 22, name: "纺织"},
  {id: 23, name: "林业"},
  {id: 24, name: "电子"},
  {id: 25, name: "教育"},
  {id: 26, name: "科研"},
  {id: 27, name: "物流"},
  {id: 28, name: "模具"},
  {id: 29, name: "板材加工"},
  {id: 30, name: "电信"},
  {id: 31, name: "其他"}
]
dictionary.CustomerType = [
  {id: 1, name: "4S店"},
  {id: 2, name: "经销商"},
  {id: 3, name: "最终用户"}
]
dictionary.dispatchPriority = [
  {id: 1, name: "低"},
  {id: 2, name: "中"},
  {id: 3, name: "高"},
  {id: 4, name: "加急"}
]
dictionary.dispatchStatus = [
  // (APP:0未完成)、1未接单、2已接单、3已出发、4已到达、5等备件、6备件到达、7待观察、8已完成、9电话完成、10已撤销
  {id: 1, name: "未接单"},
  {id: 2, name: "已接单"},
  {id: 3, name: "已出发"},
  {id: 4, name: "已到达"},
  {id: 5, name: "等备件"},
  // {id: 6, name: "备件到达"},
  {id: 7, name: "待观察"},
  {id: 8, name: "已完成"},
  {id: 9, name: "电话完成"},
  {id: 10, name: "已撤销"}
]
dictionary.isCrossAreaArray = [
  {id: 0, name: "本区派工"},
  {id: 1, name: "跨区派工"}
]
dictionary.infoSource = [
  {id: 0, name: "400电话"},
  {id: 1, name: "机头"},
  {id: 2, name: "微信"},
  {id: 3, name: "工程师扫码报修"},
  {id: 4, name: "APP代报修"},
  {id: 6, name: "WIS"},
  {id: 7, name: "跨租户转单"},
  {id: 8, name: "app工程师报修"},
  {id: 9, name: "BOX"}
]
dictionary.dealStatus = [
  // 1已保存、2已撤销、3已派工、4已结单、5服务报告已审核,可结单、6已转单
  {id: 1, name: "已保存"},
  {id: 2, name: "已撤销"},
  {id: 3, name: "已派工"},
  {id: 4, name: "已结单"},
  {id: 5, name: "已完成"},
  {id: 6, name: "已转单"},
  {id: 7, name: "已指派"},
  {id: 8, name: "已拒绝"}
]
dictionary.reportStatus = [
  // 新建, 已保存, 待审核, 已审核，已驳回
  // {id:1,name:"新建"},
  {id: 2, name: "已保存"},
  {id: 3, name: "待审核"},
  {id: 4, name: "已审核"},
  {id: 5, name: "已驳回"}
]
dictionary.serviceMethod = [
  {id: 1, name: "电话完成"},
  {id: 2, name: "现场完成"}
]
dictionary.boolean = [
  {id: 1, name: "是"},
  {id: 0, name: "否"}
]
dictionary.warrantyStatusArray = [
  {id: 0, name: "保外"},
  {id: 1, name: "保内"},
  {id: 2, name: "待定"}
]
/*
* 审核状态(列表处)
*/
dictionary.auditStatusFilter = [
  {id: 2, name: "待审核"},
  {id: 3, name: "已审核"},
  {id: 4, name: "已驳回"}
]
/* 服务详情中, 服务结果选择（服务故障）
* 1 等备件; 2 待观察;3 完成;4 电话完成
*/
dictionary.serviceDetailResultArray = [
  {id: 1, name: "等备件"},
  {id: 2, name: "待观察"},
  {id: 3, name: "完成"},
  {id: 4, name: "电话完成"}
]
/* IS_FREE 无偿/有偿
* 1无偿、0有偿
*/
dictionary.isFreeArray = [
  {id: 1, name: "无偿"},
  {id: 0, name: "有偿"}
]
/* 服务详情中, 情况说明
* 1 系统保修期外、2 使用环境不符合标准、3 现场油污严重、4 现场粉尘严重、
* 5 机器进水导致、6 现场使用不当、7 非系统类服务、8 增值服务、
* 9 设备联网、10 其它
*/
dictionary.situationDescriptionArray = [
  {id: 1, name: "系统保修期外"},
  {id: 2, name: "使用环境不符合标准"},
  {id: 3, name: "现场油污严重"},
  {id: 4, name: "现场粉尘严重"},
  {id: 5, name: "机器进水导致"},
  {id: 6, name: "现场使用不当"},
  {id: 7, name: "非系统类服务"},
  {id: 8, name: "增值服务"},
  {id: 9, name: "设备联网"},
  {id: 10, name: "其它"}
]
/*
* 审核状态（服务报告）
*/
dictionary.auditStatus = [
  {id: 1, name: "已保存"},
  {id: 2, name: "待审核"},
  {id: 3, name: "已审核"},
  {id: 4, name: "已驳回"}
]
 // 服务结果
 dictionary.serverResults = [
  // 等备件, 待观察, 完成, 电话完成
  {id: 1, name: "等备件"},
  {id: 2, name: "待观察"},
  {id: 3, name: "完成"},
  {id: 4, name: "电话完成"}
]
// 服务评价
dictionary.serviceComment = [
  // 等备件, 待观察, 完成, 电话完成
  {id: 5, name: "非常满意"},
  {id: 4, name: "满意"},
  {id: 3, name: "一般"},
  {id: 2, name: "不满意"},
  {id: 1, name: "非常不满"}
]

export default dictionary